module.exports = __webpack_public_path__ + "img/Qualification_6.675f188d.jpg";